
import { Form , Field, ChildForm } from '../form/form';
import { FormData } from '../form/formData';
import { SelectOption, Vo } from '../form/types';
import { Validators } from '@angular/forms'
import { ServiceAgent} from '../form/serviceAgent';

export class SubjectGradeStatisticsForm extends Form {
	private static _instance = new SubjectGradeStatisticsForm();

	public static getInstance(): SubjectGradeStatisticsForm {
		return SubjectGradeStatisticsForm._instance;
	}

	constructor() {
		super();
		this.fields = new Map();
		this.controls = new Map();
		this.opsAllowed = {filter: true, get: true};
	}

	public getName(): string {
		 return 'subjectGradeStatistics';
	}
}


export class SubjectGradeStatisticsFd extends FormData {
	constructor(form: SubjectGradeStatisticsForm, sa: ServiceAgent) {
		super(form, sa);
	}
	/**  this form has no editable fields. data nust be accessed as Vo and not through fd **/
}


export interface SubjectGradeStatisticsVo extends Vo {
	grade?: string, 
	nbr?: number
}
